"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const parseWithPointers_1 = require("./parseWithPointers");
exports.parse = (value) => parseWithPointers_1.parseWithPointers(value).data;
//# sourceMappingURL=parse.js.map